import _ from 'underscore';
import { useCallback, useState, useMemo, useEffect } from 'react';
import { odata } from '@bingads-webui/http-util';
import { useDeepMemo } from '@bingads-webui-campaign-react/common-hooks';

import { useOdataOptions } from './use-odata-options';
import { useIsEstimationApiSupportedLocale } from './use-is-estimation-api-supported-locale';

export const useAudienceReachEstimationV2 = (targets, isEnabled = false) => {
  const [OdataOptions, { aid, cid }] = useOdataOptions();
  const isEstimationApiSupportedLocale = useIsEstimationApiSupportedLocale();

  const endPoint = `Customers(${cid})/Accounts(${aid})/Default.AudienceEstimationV2`;

  const options = useMemo(() => ({
    ...OdataOptions,
    path: 'AdInsight/V2/', // override the default path
    url: endPoint,
  }), [OdataOptions, endPoint]);

  const payload = useDeepMemo({
    request: targets,
  });

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);

  const getAudienceReachEstimation = useCallback(() => {
    if (_.isEmpty(payload.request) || !isEstimationApiSupportedLocale || !isEnabled) {
      const defaultData = {
        EstAudienceSize: {
          Value: 0,
          Unit: 'None',
        },
      };
      setData(defaultData);

      return Promise.resolve(defaultData);
    }

    setIsLoading(true);

    return odata.post({
      ...options,
      data: payload,
    })
      .then((res) => {
        setData(res);
        return res;
      })
      .catch(err => Promise.reject(err))
      .finally(() => {
        setIsLoading(false);
      });
  }, [isEnabled, isEstimationApiSupportedLocale, options, payload]);

  useEffect(() => {
    if (!_.isEmpty(payload.request)) {
      getAudienceReachEstimation();
    }
  }, [getAudienceReachEstimation, payload.request]);

  return [{ isLoading, data }, getAudienceReachEstimation];
};
